module.exports = __webpack_public_path__ + "assets/img/show.70a41dbf.png";